import { Input } from "components";
import { MaskHelper } from "helpers";
import { useBlurHandler, useChangeHandler, usePrefixedSetter } from "helpers/FieldHandlerHelper";
import { applicationDataSections } from ".";
import { Section, SectionContent, SectionHeader, SectionItem } from "../layout";
import { ApplicantDataFields, ApplicationFields, ApplicationFormik } from "../types";

const placeholders = {
	tel: "(00) 00000-0000",
	email: "email@gmail.com",
	physicalPersonDocument: "000.000.000-00"
} as const;

const applicantDataPrefix = ApplicationFields.applicantData;

export default function ApplicantDataSection({ formik }: Readonly<ApplicationFormik>): JSX.Element {
	const errors = formik.errors?.applicantData;
	const touched = formik.touched?.applicantData;

	const setApplicationFieldValue = usePrefixedSetter(applicantDataPrefix, formik.setFieldValue);
	const handleChange = useChangeHandler(setApplicationFieldValue);

	const setApplicationFieldTouched = usePrefixedSetter(applicantDataPrefix, formik.setFieldTouched);
	const handleBlur = useBlurHandler(setApplicationFieldTouched);

	const { applicantData: values } = formik.values;

	return (
		<Section>
			<SectionHeader title="Dados Pessoais" />

			<SectionContent id={`section-${applicationDataSections.applicantData}`}>
				<SectionItem colSpan={12}>
					<Input
						type="text"
						name={ApplicantDataFields.applicantName}
						label="Nome/Razão social"
						value={values.applicantName}
						error={errors?.applicantName}
						touched={touched?.applicantName}
						onChange={handleChange}
						onBlur={handleBlur}
						disabled
					/>
				</SectionItem>
			</SectionContent>
			<SectionContent>
				<SectionItem colSpan={6}>
					<Input
						type="text"
						name={ApplicantDataFields.applicantDocument}
						label="CPF/CNPJ"
						placeholder={placeholders.physicalPersonDocument}
						value={MaskHelper.mixedCpfCnpj(values.applicantDocument)}
						error={errors?.applicantDocument}
						touched={touched?.applicantDocument}
						onChange={(evt) => handleChange(evt, MaskHelper.mixedCpfCnpj)}
						onBlur={handleBlur}
						disabled
					/>
				</SectionItem>
				<SectionItem colSpan={6}>
					<Input
						type="tel"
						name={ApplicantDataFields.applicantPhoneNumber}
						label="Telefone"
						value={MaskHelper.phone(values.applicantPhoneNumber)}
						error={errors?.applicantPhoneNumber}
						touched={touched?.applicantPhoneNumber}
						placeholder={placeholders.tel}
						onChange={(evt) => handleChange(evt, MaskHelper.phone)}
						onBlur={handleBlur}
						disabled
					/>
				</SectionItem>
			</SectionContent>
			<SectionContent>
				<SectionItem colSpan={12}>
					<Input
						type="email"
						name={ApplicantDataFields.applicantEmail}
						label="E-mail"
						value={values.applicantEmail}
						error={errors?.applicantEmail}
						touched={touched?.applicantEmail}
						placeholder={placeholders.email}
						onChange={handleChange}
						onBlur={handleBlur}
						disabled
					/>
				</SectionItem>
			</SectionContent>
		</Section>
	);
}
